import styled from 'styled-components';


const BookName = styled.div`
    width: 50%;
    align-items: center;
`

export default BookName;